import { render, staticRenderFns } from "./RoleSettingsAdministration.vue?vue&type=template&id=c252f3fe&scoped=true&"
import script from "./RoleSettingsAdministration.vue?vue&type=script&lang=ts&"
export * from "./RoleSettingsAdministration.vue?vue&type=script&lang=ts&"
import style0 from "./RoleSettingsAdministration.vue?vue&type=style&index=0&id=c252f3fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c252f3fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VProgressCircular})
